import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { FlatButton, CircularProgress, Popover } from 'material-ui';
import R from 'ramda';
import ForNewDraft from './newDraft';
import ForTemplate from './template';
import ForEditedDraft from './editedDraft';
import DraftCompletionErrors from './draftCompletionErrors';
import { publishDraft as publishDraftAction } from '../../../../../stores/contracting/dialogs/dialog-constants';
import {
  toggleDraftErrorsDialog as toggleDraftErrorsDialogAction,
  toggleShowChangesPopover as toggleShowChangesPopoverAction,
  discardEditedDraft as discardEditedDraftAction,
} from '../../../../../stores/contracting/contract-activities-products/contract-activities-products-actions';
import StagedUpdatesText from '../../../generic-components/template-staged-updates-text-flag';
import EditHistories from '../../../generic-components/editHistories';
import { Link } from 'react-router';

const isNilOrEmpty = R.either(R.isNil, R.isEmpty);
const propTypes = {
  isADraft: PropTypes.bool,
  leftNav: PropTypes.object,
  processing: PropTypes.bool,
  showDraftChangesPopover: PropTypes.object,
  toggleDraftErrorsDialog: PropTypes.func,
  toggleShowChangesPopover: PropTypes.func,
  discardEditedDraft: PropTypes.func,
  publishDraft: PropTypes.func,
  productsMap: PropTypes.object,
  openPublishConfirmation: PropTypes.func,
  removeDraftFromQueue: PropTypes.func,
  contractId: PropTypes.string,
  isDummyAccount: PropTypes.bool,
  isAnAdmin: PropTypes.bool,
  pureDocView: PropTypes.bool,
  acctCreationReason: PropTypes.string,
  forCC: PropTypes.bool,
};
const DraftProgressIndicator = (props) => {
  const {
    isADraft,
    leftNav,
    showDraftChangesPopover,
    toggleDraftErrorsDialog,
    toggleShowChangesPopover,
    discardEditedDraft,
    contractId,
    isDummyAccount,
    pureDocView,
    acctCreationReason,
    // forCC,
  } = props;
  const isEditedDraft = leftNav.originFrom === 'edited';
  const isEditedTemplate = leftNav.templateHasDraft;
  const discardEditedDraftWithRouting = () => {
    discardEditedDraft(contractId);
  };
  return (
    <div>
      <div style={{ padding: '0 2px' }}>
        {
          R.call(R.cond([
            // [() => forCC, R.always(<h4>Actual rate amount are hidden for privacy reasons.</h4>)],
            [() => pureDocView || acctCreationReason === 'al-account', R.always(<div/>)],
            // [() => isDummyAccount, R.always(<ForCR {...props} />)],
            [() => isADraft && !isEditedDraft, R.always(<ForNewDraft {...props} />)],
            [() => isADraft && isEditedDraft, R.always(<ForEditedDraft {...props} />)],
            [R.T, R.always(<ForTemplate {...props} />)],
          ]))
        }
      </div>
      <DraftCompletionErrors onRequestClose={toggleDraftErrorsDialog} />
      <Popover
        open={showDraftChangesPopover.open}
        anchorEl={showDraftChangesPopover.anchorEl}
        anchorOrigin={{ horizontal: 'middle', vertical: 'bottom' }}
        targetOrigin={{ horizontal: 'right', vertical: 'top' }}
        onRequestClose={toggleShowChangesPopover(false)}
        style={{ padding: '16px' }}
      >
        {
          leftNav.diffSummary && leftNav.diffSummary.loading && (
            <div style={{ textAlign: 'center', padding: '10px' }}>
              <CircularProgress size={30}/>
            </div>
          )
        }
        {
          !isNilOrEmpty(leftNav.diffSummary) ?
            <EditHistories
              diffSummary={leftNav.diffSummary}
            /> : <span>You haven't made any changes yet.</span>
        }
        <Link to={`/contracting/reports/diff/draft/${contractId}/${contractId}`} style={{ color: '#00b3cf' }}>View side by side comparison</Link>
      </Popover>
      {
        R.call(R.cond([
          [() => leftNav.stagedUpdates && leftNav.stagedUpdates.length, R.always(
            <div style={{ margin: '8px 12px', display: 'flex', flexDirection: 'row-reverse', alignItems: 'center' }}>
              <StagedUpdatesText
                style={{ textAlign: 'right' }}
                stagedUpdates={leftNav.stagedUpdates}
                updateInitiated={leftNav.updateInitiated}
                isEditedTemplate={isEditedTemplate}
                isEditedDraft={isEditedDraft}
                refreshSection="doc"
              />
            </div>
          )],
          [() => isEditedDraft && !pureDocView, R.always(
            <div className="flex-tc-sb" style={{ margin: '8px 0', flexDirection: 'row-reverse' }}>
                {
                  leftNav.draftType === 'contract' ? (
                    <span>
                  This draft was created from this <a style={{ cursor: 'pointer' }} href={`/contracting/contract/${contractId}/details`}> contract</a>.
                </span>
                  ) : (
                    <span>
                  This draft was created from this <a style={{ cursor: 'pointer' }} href={`/contracting/template/${contractId}/details`}> template</a>.
                </span>
                  )
                }
              <div className="flex-center">
                <FlatButton
                  secondary
                  label={R.isEmpty(leftNav.editHistory) ? `You haven't made any changes yet.` : 'View Changes'}
                  labelStyle={{ textTransform: 'none', lineHeight: '30px', height: '30px', padding: '4px', verticalAlign: '', top: '-2px' }}
                  style={{ height: '30px', display: 'block', border: R.isEmpty(leftNav.editHistory) ? 'none' : '1px solid #00bcd4' }}
                  disabled={R.isEmpty(leftNav.editHistory)}
                  onTouchTap={toggleShowChangesPopover(true)}
                />
                <FlatButton
                  primary
                  label={R.isEmpty(leftNav.editHistory) ? 'Discard Draft' : 'Discard Changes'}
                  labelStyle={{ textTransform: 'none', lineHeight: '30px', height: '30px', padding: '4px', verticalAlign: '', top: '-2px' }}
                  style={{ height: '30px', border: '1px solid #ff4081', marginLeft: '8px' }}
                  onTouchTap={discardEditedDraftWithRouting}
                />
              </div>
            </div>
          )],
          [() => isEditedDraft && pureDocView, R.always(
            <FlatButton
              secondary
              label={R.isEmpty(leftNav.editHistory) ? `You haven't made any changes yet.` : 'View Changes'}
              labelStyle={{ textTransform: 'none', lineHeight: '30px', height: '30px', padding: '4px', verticalAlign: '', top: '-2px' }}
              style={{ height: '30px', display: 'block', border: R.isEmpty(leftNav.editHistory) ? 'none' : '1px solid #00bcd4', marginBottom: '8px' }}
              disabled={R.isEmpty(leftNav.editHistory)}
              onTouchTap={toggleShowChangesPopover(true)}
            />
          )],
          [() => isEditedTemplate, R.always(
            <div style={{ margin: '8px 12px', display: 'flex', flexDirection: 'row-reverse', alignItems: 'center' }}>
              <span>This template has a <a style={{ cursor: 'pointer' }} href={`/contracting/draft/${contractId}/details`}>
                draft
              </a>.
              </span>
            </div>
          )],
          [R.T, R.always(<div style={{ height: '12px' }}/>)],
        ]))
      }
    </div>
  );
};
DraftProgressIndicator.propTypes = propTypes;

const mapStateToProps = state => {
  const { contracting, user } = state;
  const contractingState = contracting.contractActivitiesProducts.toJS();
  const leftNav = contractingState.leftNav;
  return ({
    leftNav,
    errors: contractingState.draftErrors,
    showDraftChangesPopover: contractingState.showDraftChangesPopover,
    realActorEmail: user.get('realActorEmail'),
    isAnAdmin: user.get('isAnAdmin'),
    pureDocView: user.get('pureDocView'),
    forCC: user.get('forCC'),
    acctCreationReason: user.getIn(['company', 'acctCreationReason']),
  });
};
const mapDispatchToProps = dispatch => ({
  publishDraft: (...args) => dispatch(publishDraftAction(...args)),
  toggleDraftErrorsDialog: (...args) => dispatch(toggleDraftErrorsDialogAction(...args)),
  toggleShowChangesPopover: R.curry((open, event) => dispatch(toggleShowChangesPopoverAction(open, event))),
  discardEditedDraft: (...args) => dispatch(discardEditedDraftAction(...args)),
  goToSendUpdates: () => dispatch({ type: 'SEND_UPDATES_IN_PUBLISH_DRAFT_DIALOG' }),
  openPublishConfirmation: () => dispatch({ type: 'UPDATE_PROPS_IN_PUBLISH_DRAFT_DIALOG', payload: { open: true, title: 'Finalise Template' } }),
});
export default connect(mapStateToProps, mapDispatchToProps)(DraftProgressIndicator);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/draftNTemplate-container/progressIndicatorBar/progressIndicatorContainer.jsx